/* @flow */

module.exports = {
  "LOCALE": {
    "CURRENCY": "SEK",
    "CURRENCY_SHORT": "kr",
    "POINTS": "",
  },
  "META": {
    "HELPDESK_LINK": "http://helpdesk.crossroads.se/?s=15e4e4fcc649e015e4e4fcc64a16",
  },
  "SKIP_TO_CONTENT": "Gå till innehåll",
  "URL": {
    "CHECKOUT_CART": "/checkout/cart",
    "CHECKOUT_OVERVIEW": "/checkout/overview",
    "CHECKOUT_SUCCESS": "/checkout/success",
    "CHECKOUT_FAILED": "/checkout/overview",
  },
  "LOGO": {
    "ALT": "Zupergift.com",
    "TITLE": "Gå till startsidan",
  },
  "COMMON": {
    "OR": "Eller",
  },
  "COOKIE_CONSENT": {
    "ALL": "Tillåt alla",
    "SELECTED": "Tillåt urval",
    "NECESSARY": "Tillåt nödvändiga",
  },
  "COOKIE_OPTIONS": {
    "NECESSARY": "Nödvändiga",
    "STATISTICAL": "Statistiska",
    "MARKETING": "Marknadsföring",
  },
  "ROUTES": {
    "ALL_GIFTCARDS": "/alla-presentkort",
  },
  "CLOSE_SYSTEM_MESSAGE": "Stäng meddelande",
  "HOMEVIEW": {
    "POPULAR_BRANDS": "Populära varumärken",
    "POPULAR_CATEGORIES": "Populära kategorier",
    "POPULAR_PRODUCTS": "Populära presentkort",
    "ALL_CATEGORIES": "Alla kategorier",
    "MORE_POPULAR_PRODUCTS": "Fler populära produkter",
    "TUTORIAL": "Så fungerar det",
  },
  "COMPANYVIEW": {
    "HERO": {
      "TITLE": "Presentkort för företag",
      "CONTENT": "Digitala presentkort som gör företagsgåvor enkla. Ni väljer värde – mottagaren väljer själv bland hundratals välkända varumärken. En flexibel lösning som sparar tid och stärker relationer.",
      "LIST_ITEM_1": "Snabb digital leverans",
      "LIST_ITEM_2": "100+ välkända varumärken",
      "LIST_ITEM_3": "Trygg hantering med personlig support",
    },
    "POPULAR_TITLE": "Populära varumärken du hittar hos oss",
    "TRUSTED_TITLE": "Företag och organisationer som valt Awardit",
    "CTA_1": "Offertförfrågan",
    "CTA_LINK_1": "https://share-eu1.hsforms.com/2QJ6B_Om_TlGIl9KKbMikpQ2dd4ic",
    "CTA_2": "Kontakta oss",
    "CTA_LINK_2": "https://helpdesk.crossroads.se/?s=15e4e4fcc649e015e4e4fcc64a16",
    "CTA_3": "Skapa företagskonto",
    "CTA_LINK_3": "https://awarditrewards.se/account/create",
    "FIELD_1": {
      "TITLE": "Digitala presentkort från 100+ välkända varumärken",
      "TEXT_CONTENT": "Ge mottagaren friheten att välja själv från ett brett utbud inom mode, sport, elektronik, resor och upplevelser. Perfekt för julklappar, bonus, incitament och kampanjer där ni vill skapa verklig motivation. Enkel att skicka. Liten insats. Stor påverkan.",
      "CTA": "Se utbud",
      "CTA_LINK": "/alla-presentkort",
    },
    "FIELD_2": {
      "TITLE": "Så fungerar våra företagsgåvor",
      "LIST_ITEM_1": "1. Skapa företagskonto",
      "LIST_ITEM_2": "2. Lägg till användare",
      "LIST_ITEM_3": "3. Begär faktura",
      "LIST_ITEM_4": "4. Konto toppas upp",
      "LIST_ITEM_5": "5. Skicka ut presentkort",
      "LIST_ITEM_6": "6. Se statistik samlad i portalen",
    },
    "FIELD_3": {
      "TITLE": "Skattefritt enligt gällande regler",
      "TEXT_CONTENT": "Genom att följa Skatteverkets beloppsgränser kan företag ge skattefria gåvor till sina medarbetare:",
      "LIST_ITEM_1": "Julgåva upp till 600 kr inkl. moms",
      "LIST_ITEM_2": "Jubileumsgåva upp till 1 800 kr inkl. moms",
      "LIST_ITEM_3": "Minnesgåva upp till 15 000 kr inkl. moms",
      "FOOTER": "Med Zupergift får ni en lösning som är anpassad efter regelverket – smidig administration och full kontroll från början till slut.",
    },
    "FIELD_4": {
      "TITLE": "Gör uppskattning till en naturlig del av er företagskultur",
      "TEXT_CONTENT": "Uppskattning ska vara en del av vardagen, inte bara något som händer vid årets högtider. Med Awardit Rewards kan ni uppmärksamma allt från onboarding och viktiga milstolpar till uppnådda mål, jubileum och extra säljsatser och samtidigt stärka motivationen i rätt ögonblick.",
      "LIST_HEADER": "Genom att arbeta strukturerat med uppskattning skapar ni:",
      "LIST_ITEM_1": "Starkare lojalitet",
      "LIST_ITEM_2": "Högre engagemang",
      "LIST_ITEM_3": "Ökad prestation",
      "LIST_ITEM_4": "En mer attraktiv arbetsplats",
      "FOOTER": "Små signaler, konsekvent levererade, ger stor effekt över tid. När uppskattning blir en vana istället för en kampanj skapar ni en kultur som håller och som märks i resultaten.",
    },
    "FIELD_5": {
      "TITLE": "Skapa och skicka presentkort helt på egen hand",
      "TEXT_CONTENT": "Med vår kostnadsfria belöningsportal Awardit Rewards kan ni enkelt skicka och administrera gåvor med allt från enstaka utskick till flera hundra mottagare samtidigt.",
      "LIST_HEADER": "Ni får:",
      "LIST_ITEM_1": "Full kontroll över budget och distribution",
      "LIST_ITEM_2": "Enkel administration",
      "LIST_ITEM_3": "Möjlighet att schemalägga utskick",
      "LIST_ITEM_4": "En lösning som stärker retention och employer brand",
      "FOOTER": "Helt gratis att använda. Ingen bindningstid. Passar för både små och stora företag.",
    },
  },
  "TUTORIAL": {
    "STEP_1": {
      "TITLE": "1",
      "TEXT": "Köp Zupergift",
      "LINK": "/zupergift",
    },
    "STEP_2": {
      "TITLE": "2",
      "TEXT": "Leverans direkt via e-post",
    },
    "STEP_3": {
      "TITLE": "3",
      "TEXT": "Lös in Zupergift",
      "LINK": "/redeem",
    },
    "STEP_4": {
      "TITLE": "4",
      "TEXT": "Välj presentkort ",
      "LINK": "/alla-presentkort",
    },
  },
  "REDEEM": {
    "HEADING": "Lös in ditt presentkort",
    "CLOSE": "Stäng",
    "TEXT": "Börja med att ange din kod nedan. Koden hittar du i mejlet som innehöll ditt Zupergift-presentkort. I nästa steg väljer du vilket eller vilka varumärken du vill lösa in ditt presentkort till. Därefter går du till kassan och sedan landar dina val av presentkort i din e-post. Zuperenkelt!",
    "PLACEHOLDER_CODE": "Ange kod",
    "PLACEHOLDER_PIN": "Ange pin",
    "SUBMIT": "Spara",
    "SUCCESS_ROUTE": "/alla-presentkort",
    "HOWTO": {
      "CODE": "Ange din värdekod",
      "BALANCE": "Se ditt saldo",
      "SELECT": "Välj presentkort",
      "DELIVERY": "Leverans via e-post",
    },
  },
  "ADDRESS": {
    "FIRSTNAME": "Förnamn",
    "LASTNAME": "Efternamn",
    "STREET_1": "Gatuadress 1",
    "STREET_2": "Gatuadress 2 (frivilligt)",
    "POSTCODE": "Postnummer",
    "CITY": "Stad",
    "COUNTRY": "Land",
    "EMAIL": "E-mail",
    "TELEPHONE": "Telefon",
  },
  "CAROUSEL": {
    "ITEM_LABEL": "Artikel %current av %total",
    "CONTROLS": {
      "LABEL": "Navigation för karusell",
      "PREV_ITEM_GROUP_LABEL": "Föregående artikelgrupp",
      "NEXT_ITEM_GROUP_LABEL": "Nästa artikelgrupp",
      "GO_TO_ITEM_GROUP_LABEL": "Gå till artikelgrupp %number",
      "PLAY_LABEL": "Starta automatisk uppspelning",
      "PAUSE_LABEL": "Pausa automatisk uppspelning",
    },
  },
  "DIALOGUE": {
    "CLOSE": "Stäng dialog",
  },
  "NOTIFICATIONBAR": {
    "CLOSE": "Stäng banner",
  },
  "OR": "eller",
  "CART": {
    "CLOSE": "Stäng varukorgen",
    "HEADING": "Varukorg",
    "TOTALS": "Totalt",
    "YOUR_BALANCE": "Ditt saldo",
    "AFTER_PURCHASE": "Saldo efter köp",
    "VALID_TO": "Giltig tom",
    "PAY_VOUCHER": "Presentkort",
    "EMPTY": "Varukorgen är tom",
    "INCREMENT": "Öka kvantitet",
    "DECREMENT": "Minska kvantitet",
    "QUANTITY": "Kvantitet",
    "NAV_BUTTON": "Gå till varukorgen, det finns %amount produkt(er)",
    "CTA": "Gå till varukorgen",
    "PRODUCTS": "Produkter",
    "SHIPPING": "Frakt",
    "SUMMARY": "Summering",
    "TO_CHECKOUT": "Gå till kassan",
    "DIALOG_CANCEL": "Avbryt",
    "REMOVE_PRODUCT": "Ta bort produkt",
    "REMOVE_APPROVE": "Ja, ta bort",
    "CONFIRM_TEXT": "Vill du verkligen ta bort '%itemName' från varukorgen?",
    "CONTINUE_SHOPPING": "Fortsätt handla",
    "DISCOUNT": "Rabatt",
    "SUB_TOTAL": "Summa",
    "GRAND_TOTAL": "Totalt att betala",
    "CLOSE_SUMMARY": "Stäng summeringen",
    "OPEN_SUMMARY": "Öppna summeringen",
    "SUBMIT": "Spara antal produkter",
  },
  "CHECKOUT": {
    "TITLE": "Kassa",
    "CONTINUE": "Fortsätt",
    "TO_PAYMENT": "Gå till betalning",
    "AMOUNT_TO_PAY": "Att betala",
    "EDIT": "Ändra",
    "BACK_TO_CART_TEXT": "Tillbaka till varukorgen",
    "COMPLETE_PURCHASE": "Slutför köp",
    "REDEEM_LABEL_CODE": "Presentkortskod",
    "REDEEM_LABEL_PIN": "Ange tillhörande pinkod",
    "REDEEM_SUBMIT": "Använd",
    "OPT_EMAIL": "Jag vill få information om erbjudanden från Zupergift",
    "I_ACCEPT_THE": "Jag accepterar",
    "TERMS": "köpvillkoren",
    "TERMS_URL": "villkor",
    "TERMS_CLOSE": "Stäng köpvillkor",
    "PAYMENT_METHOD_STEP": "Välj betalningsmetod",
    "PAY_STEP": "Gå till säker betalning",
    "VIRTUAL_TERMS": "Jag samtycker till att det digitala presentkortet levereras omedelbart och är medveten om att detta innebär att jag inte längre har ångerrätt.",
    "ADDRESS": {
      "ADDRESS": "Faktura & leveransinformation",
      "SHIPPING": "Leveransadress",
      "SHIP_TO_SAME_ADDRESS": "Leverera till samma adress",
    },
    "DISCOUNT_CODE": {
      "HEADER": "Rabattkod",
      "PLACEHOLDER": "Ange rabattkod",
      "APPLY": "Använd",
      "REMOVE": "Ta bort",
    },
  },
  "PAYMENT_METHODS": {
    "ALTAPAY": {
      "CARD": "Betala med kort" },
  },
  "SUCCESS": {
    "HELMET_TITLE": "Orderbekräftelse",
    "TITLE": "Beställning registrerad",
    "SUB_TITLE": "Ordernummer %number",
    "BACK": "Fortsätt handla",
    "NOT_FOUND_TITLE": "Ingen order hittades.",
    "NOT_FOUND_SUBTITLE": "Vänligen kontakta kundtjänst om detta är felaktigt.",
    "WHAT_NOW": "Så vad händer nu?",
    "STEPS": {
      "HEADING": "Beställning registrerad",
      "WHAT_NOW": "Så vad händer nu?",
      "LABEL": "Din beställning",
      "ORDER_ID": "Ordernummer %id",
      "QUESTIONS": {
        "HEADING": "Har du en fråga om din beställning?",
        "LABEL": "Gå till kundtjänst",
        "URL": "/faq",
      },
      "NORMAL": {
        "1": {
          "HEADING": "Bekräftelse",
          "TEXT": "En orderbekräftelse kommer att skickas till %email inom kort.",
        },
        "2": {
          "HEADING": "Bearbetning",
          "TEXT": "Din beställning skickas när samtliga produkter finns tillgängliga för leverans. Vanligen sker detta redan nästkommande dag.",
        },
        "3": {
          "HEADING": "Transport",
          "TEXT": "När dina varor packats och skickats så meddelas du via e‑post. I leveransbekräftelsen finner du en spårningslänk med vilken du kan följa paketets väg. Leveransen tar normalt 1–2 dagar.",
        },
        "4": {
          "HEADING": "Leverans",
          "TEXT": "Vissa paket levereras direkt i din brevlåda. Paket som är för stora levereras i stället till ett utlämningsställe och aviseras via sms till det mobilnummer du har angivit i beställningen. Paket ligger kvar på utlämningsstället i 14 dagar.",
        },
      },
      "MIXED": {
        "1": {
          "HEADING": "Bekräftelse",
          "TEXT": "En orderbekräftelse och dina digitala biljetter/värdekoder kommer att skickas till %email inom kort. Har du inte fått någon e‑post ber vi dig dubbelkolla ditt spam-filter innan du kontaktar kundservice.",
        },
        "2": {
          "HEADING": "Bearbetning",
          "TEXT": "Din beställning skickas när samtliga produkter finns tillgängliga för leverans. Vanligen sker detta redan nästkommande dag.",
        },
        "3": {
          "HEADING": "Transport",
          "TEXT": "När dina varor packats och skickats så meddelas du via e‑post. I leveransbekräftelsen finner du en spårningslänk med vilken du kan följa paketets väg. Leveransen tar normalt 1–2 dagar.",
        },
        "4": {
          "HEADING": "Leverans",
          "TEXT": "Vi skickar dina digitala biljetter/värdekoder till %email inom kort. Din fysiska leverans skickas med DBSchenker. Vissa paket levereras direkt i din brevlåda. Paket som är för stora levereras i stället till ett utlämningsställe och aviseras via sms till det mobilnummer du har angivit i beställningen. Paket ligger kvar på utlämningsstället i 14 dagar.",
        },
      },
      "VIRTUAL": {
        "1": {
          "HEADING": "Bekräftelse",
          "TEXT": "Du kommer att få en orderbekräftelse till %email.",
        },
        "2": {
          "HEADING": "Digital leverans",
          "TEXT": "Vi skickar dina digitala biljetter/värdekoder till %email inom kort. Har du inte fått någon e‑post ber vi dig dubbelkolla ditt spam-filter innan du kontaktar kundservice.",
        },
      },
    },
    "CONTACT": {
      "TITLE": "Undrar du något?",
      "INFO": "Vi svarar på dina frågor angående leverans, produkter eller sortimentet inom 48 timmar på helgfria vardagar.",
      "CREATE_TICKET": "Skriv till oss via vårt kontaktformulär",
    },
  },
  "CATEGORY": {
    "EMPTY": "Det finns inga produkter att visa just nu",
    "LOAD_MORE": "Ladda fler",
    "PRODUCTS_IN_CATEGORY_TITLE": "Visar %itemsCount produkter i",
    "PRODUCTS_IN_CATEGORY_TITLE_SINGULAR": "Visar 1 produkt i",
    "PRODUCTS_IN_CATEGORY_TITLE_PLURAL": "Visar %itemsCount produkter i",
    "PRODUCTS_IN_CATEGORY_TITLE_EMPTY": "Visar produkter i",
  },
  "ALL_GIFTCARDS": {
    "TITLE": "Alla presentkort",
  },
  "404": {
    "TITLE": "Sidan kunde inte hittas",
    "HEADING": "— 404 —",
    "SUBHEADING": "Sidan kunde inte hittas",
  },
  "SERVER_ERROR": {
    "TITLE": "Serverfel",
    "TEXT": "<strong>Behöver du kontakta oss?</strong><br/> Skicka ett mail till <a href=\"mailto:kundservice@crossroads.se\">kundservice@crossroads.se</a>",
  },
  "SEARCH": {
    "TITLE_PREFIX": "Sök: ",
    "PLACEHOLDER": "Sök efter ett presentkort",
    "PRODUCTS_IN_SEARCH_RESULT": "Hittade %itemsCount produkter som matchade",
    "PRODUCT_IN_SEARCH_RESULT": "Hittade en produkt som matchade",
  },
  "FILTER": {
    "FILTERBAR": {
      "ALL_FILTERS": "Alla filter",
      "FILTER_BY_POINTS": "Filtrera på poäng",
      "FILTER_BY_PRICE": "Filtrera på pris",
      "PRICE_RANGE": "%min - %max kr",
      "SORT": "Sortera",
      "SORT_PRICE_DESC": "Pris ↓",
      "SORT_PRICE_ASC": "Pris ↑",
      "SORT_NAME_DESC": "Namn ↓",
      "SORT_NAME_ASC": "Namn  ↑",
    },
    "OFFCANVAS": {
      "TITLE": "Filter",
      "SHOW_RESULT_TOTAL_SINGLE": "%total Produkt",
      "SHOW_RESULT_TOTAL_MULTIPLE": "%total Produkter",
      "SHOW_RESULT": "Visa resultat",
      "CLOSE_MENU": "Stäng filter",
    },
    "ACTIVE_FILTERS": {
      "CLEAR_ALL": "Rensa filter",
      "NO_ACTIVE_FILTERS": "Du har inga aktiva filter",
      "PRICE_RANGE": "Pris (%range)",
    },
    "FILTERMENU": {
      "FILTER_BY_PRICE": "Filtrera på poäng",
      "FILTER_BY_POINTS": "Filtrera på pris",
      "RESET_PRICE": "Rensa filter",
      "PRICE_FROM": "Från",
      "PRICE_TO": "Till",
    },
  },
  "HEADER": {
    "MAIN_NAVIGATION": "Huvudmeny",
    "OPEN_MENU": "Öppna menyn",
    "CLOSE_MENU": "Stäng menyn",
    "BACK": "Gå tillbaka",
    "SEARCH": "Sök",
    "OPEN_SEARCH": "Öppna sök",
    "CLOSE_SEARCH": "Stäng sök",
    "ALL_GIFTCARDS": "Alla presentkort",
    "BUY_ZUPERGIFT": "Köp Zupergift",
    "REDEEM_GIFTCARD": "Lös in Zupergift",
    "CATEGORIES": "Kategorier",
    "COMPANY": "Företag",
    "CART": "Varukorg",
    "HELP": "Kontakt",
    "ABOUT": "Hur fungerar det?",
    "CLOSE_CATEGORIES": "Stäng kategorier",
    "OCCASIONS": "Tillfällen",
    "CLOSE_OCCASIONS": "Stäng tillfällen",
    "BANNER": {
      "TEXT": "Prenumerera på nyhetsbrev för erbjudanden och rabatter!",
      "BUTTON": "Registrera dig här",
    },
  },
  "NEWSLETTERBANNER": {
    "HEADER": "Prenumerera på vårt nyhetsbrev och ta del av exklusiva erbjudanden och rabatter!",
    "FORM": {
      "PLACEHOLDER": "Min epostadress",
      "BUTTON_TEXT": "Prenumerera",
    },
    "TERMS": {
      "TEXT": "Läs om vår <a href=\"/se/privacy-policy\">Integritetspolicy</a>",
    },
  },
  "FOOTER": {
    "NAVIGATION": "Sidfotsmeny",
    "CATEGORIES": "Kategorier",
    "COPYRIGHT": "Copyright © %currentYear",
    "RECAPTCHA": "This site is protected by reCAPTCHA and the Google <a href=\"https://policies.google.com/privacy\">Privacy Policy</a> and <a href=\"https://policies.google.com/terms\">Terms of Service</a> apply.",
    "LANGUAGE_SWITCHER_TEXT": "You're using the Swedish version of Zupergift",
    "LANGUAGE_SWITCHER_BUTTON": "Change language/region",
    "COOKIES": "Hantera cookies",
    "TERMS_LINK": "villkor",
    "TERMS_TEXT": "Köpvillkor",
    "ACCESSIBILITY": "Tillgänglighet",
  },
  "LANGUAGE_SWITCHER": {
    "TITLE": "Welcome!",
    "CLOSE": "Close language switcher",
    "SUB_TITLE": "You're using the Swedish version of Zupergift. Do you want to change language/region?",
    "FINLAND": "Finland",
    "DENMARK": "Denmark",
    "NORWAY": "Norway",
    "SWEDEN": "Sweden",
  },
  "BREADCRUMBS": {
    "HOME_URL": "/",
    "HOME": "Hem",
    "SEARCH_RESULTS_FOR": "Sökresultat för: ",
  },
  "PRODUCT": {
    "STARTING_AT": "Från",
    "ADD_TO_CART": "Lägg i varukorg",
    "OUT_OF_STOCK": "Slut i lager",
    "DESCRIPTION": "Produktbeskrivning",
    "RELATED_PRODUCTS": "Relaterade produkter",
    "CROSS_SELL_PRODUCTS": "Andra gillade också",
    "OPTION_DROPDOWN_PLACEHOLDER": "Välj ett alternativ...",
    "CHANGE_IMAGE": "Byt bild",
  },
  "VALIDATION": {
    "REQUIRED": "Obligatoriskt fält",
    "EMAIL": "Vänligen fyll i en korrekt e‑postadress",
    "PHONE": "Vänligen fyll i ett korrekt mobiltelefonnummer",
    "NUMERIC": "Fältet får bara innehålla nummer",
    "LENGTH_LT": "Fältet innehåller för många tecken",
    "POSTCODE": "Vänligen fyll i ett korrekt postnummer (XXX XX)",
    "MATCH": "Fältet matchar inte",
    "MISSING_FIELD": "Adress saknas, försök igen",
  },
  "STATUS_CODE": {
    /* Client */
    "UNKNOWN": "Ett okänt fel har uppstått. Vänligen ladda om sidan och försök igen.",
    "NETWORK_ERROR": "Anropet avbröts. Vänligen verifiera att du har en aktiv internetanslutning eller försök igen om en stund.",
    "PLACE_ORDER_CATCH": "Ett fel uppstod. Vänligen försök igen senare.",
    "AQUIRER_DECLINE": "Betalningen har nekats. Vänligen verifiera dina kort-/kontouppgifter.",

    "errorFraudShop": "Det är inte möjligt att slutföra ett köp just nu",
    "errorFraudOrder": "Köpet är inte tillåtet. Kontakta support för mer information",
    "errorFraudProduct": "Gränsen har nåtts för en eller flera produkter i varukorgen. Kontakta support för mer information.",
    "errorFraudBlacklist": "Köpet är inte tillåtet. Kontakta support för mer information.",
    "errorDeclinedCard": "Kortet nekades.",

    "errorProductQuantityNotAvailable": "Det antal du angav finns inte tillgängligt just nu.",
    "errorProductNotInStock": "Produkten du försökte lägga i varukorgen finns dessvärre inte i lager just nu.",
    "errorProductMaxQuantity": "Det angivna antalet finns dessvärre inte i lager just nu.",
    "errorProductNotChosenVariant": "Vänligen välj %attributeLabel för att kunna lägga till produkten i din varukorg.",
    "errorBillingAddressValidationFailed": "Felaktig adress",
    "errorInvalidTelephone": "Ogiltigt telefonnummerformat.",
    "REDEEM_ERROR": {
      "_777": "Presentkortskoden är inte giltig. Kontrollera koden och försök igen.",
      "_786": "Okänt fel vid validering av koden. Kontrollera koden och försök igen.",
      "_800": "Koden är redan använd",
      "_791": "Presentkortskoden kräver en pinkod. Vänligen fyll i tillhörande pinkod och försök igen.",
      "_792": "Pinkoden är inte giltig. Kontrollera pinkoden och försök igen.",
      "RECAPTCHA": "Google ReCaptcha kunde inte valideras. Vänligen försök igen, eller testa en annan enhet och/eller webbläsare.",
    },
    "NEWSLETTER": {
      "SUCCESS": "Epost registrerad.",
      "ERROR": {
        "notModified": "Kunde inte lägga till e-post. Det är möjligt att e-postadressen redan används.",
        "invalidEmail": "Den angivna e-postadressen är ogiltig.",
        "notLoggedIn": "Var vänlig ange en giltig e-postadress. E-postfältet kan inte lämnas tomt.",
      },
    },
    "success": "Ditt presentkort är aktiverat och du kan nu lösa in värdet!",

    "NOT_ALLOWED_TO_BUY_PRODUCT_WITH_CURRENT_GIFTCODE": "Denna produkt kan inte betalas med den Zupergift-kod du just nu har aktiv. Välj en annan produkt.",
    "NOT_ALLOWED_TO_USE_GIFTCODE_WITH_CURRENT_PRODUCTS": "Vissa av produkterna i varukorgen kan inte köpas med denna koden och har därför plockats bort.",
    "NOT_ALLOWED_TO_PLACE_ORDER_WITH_PRODUCTS": "Det går inte att slutföra köpet, då din varukorg innehåller produkter som inte är tillåtna att köpas med den Zupergift-kod du just nu har aktiv.",
    "DISCOUNT_CODE_FAILURE": "Rabattkoden kunde inte appliceras, vänligt försök igen eller kontakta kundtjänst.",
    "DISCOUNT_CODE_APPLIED": "Rabattkod applicerad.",
  },
  "ICONS": {
    "ARROW": "Pil höger",
    "CHEVRON": "Pil",
    "CART": "Varukorg",
    "HEADPHONES": "Hörlurar",
    "MAGNIFIER": "Förstoringsglas",
    "CROSS": "Kryss",
    "HAMBURGER": "Tre horisontella streck (hamburgarikon)",
    "AVATAR": "Avatar",
    "DENMARK_FLAG": "Danmarks flagga",
    "FINLAND_FLAG": "Finlands flagga",
    "SWEDEN_FLAG": "Sveriges flagga",
    "NORWAY_FLAG": "Norges flagga",
  },
};
